import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useUpdateUser } from "../../api/users";
import { useToast } from "../../components/ToastProvider";
import { StaffUserRow } from "../../types/dtos";

export function EditUserModal({ user, onClose }: { user: StaffUserRow | null; onClose: () => void }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);

  const update = useUpdateUser();
  const toast = useToast();

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setError(null);
    }
  }, [user]);

  if (!user) return null;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return setError("Informe o nome.");
    if (!email.trim()) return setError("Informe o e-mail.");
    if (!user) return;

    try {
      await update.mutateAsync({ id: user.id, input: { name, email } });
      toast("Usuário atualizado.");
      onClose();
    } catch {
      setError("Não foi possível salvar — o e-mail já pode estar em uso.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Editar usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              Nome
            </label>
            <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              E-mail
            </label>
            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={update.isPending}>
            Salvar alterações
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
